export const RESOURCE_TYPE = {
  Icon: 'Icon',
  SecurityPolicyWithFallback: 'SecurityPolicyWithFallback',
  SecurityPolicyWithoutFallback: 'SecurityPolicyWithoutFallback',
  SecurityCatalog: 'SecurityCatalog',
};

const RESOURCE_TYPE_MAPPING = [
  { value: RESOURCE_TYPE.Icon, label: 'Icon', icon: 'mdi:image-outline' },
  // The with-fallback build is the only supplemental policy the product hands out, so it is just
  // "Policy" wherever it is offered.
  {
    value: RESOURCE_TYPE.SecurityPolicyWithFallback,
    label: 'Policy',
    icon: 'mdi:file-code-outline',
  },
  {
    value: RESOURCE_TYPE.SecurityPolicyWithoutFallback,
    label: 'Policy (no fallback)',
    icon: 'mdi:file-code-outline',
  },
  {
    value: RESOURCE_TYPE.SecurityCatalog,
    label: 'Security Catalog',
    icon: 'mdi:certificate-outline',
  },
];

export const getResourceTypeLabel = value =>
  RESOURCE_TYPE_MAPPING.find(item => item.value === value)?.label ?? 'Template';

export const getResourceTypeIcon = value =>
  RESOURCE_TYPE_MAPPING.find(item => item.value === value)?.icon ?? 'mdi:file-download-outline';
